import mint from './mint/mintServices'
import * as contentful from './contentful/contentfulServices'

const api = {
  contentful,
  mint,
}

export default api
